export class Commission {
    AgentId: number;
    Year: number;
    Month: number;
    CommissionAmount: number;
}